'use strict';

var deepmerge = require('../../../../../../utils/esm/deepmerge/deepmerge.cjs');

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge.default(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

module.exports = merge;
//# sourceMappingURL=merge.cjs.map
